<div color="primary">
  <div>
    <button mat-button [matMenuTriggerFor]="minhaConta">
      <div class="two-lines">
        <div class="line">
          <mat-icon class="icone">account_circle</mat-icon>
        </div>
        @if (!isMobileMenu) {
        <div>Olá, {{nomeUsuario}}</div>
        }
      </div>
    </button>
    <mat-menu #minhaConta="matMenu">
      <button mat-menu-item style="background-color: white" [routerLink]="routerLink"><b>Minha Conta</b></button>
      <mat-divider></mat-divider>
      @if (isCliente) {
      <button mat-menu-item style="background-color: white" routerLink="/minha-conta/meus-pedidos"><b>Meus Pedidos</b></button>
      <mat-divider></mat-divider>
      }
      @if (isUsuario && isMobileMenu) {
      <button mat-menu-item style="background-color: white" routerLink="/minha-conta/painel-cadastro"><b>Cadastro de Paineis</b></button>
      <mat-divider></mat-divider>
      }
      @if (isCliente) {
      <button mat-menu-item style="background-color: white" routerLink="/minha-conta/meus-titulos"><b>Meus títulos</b></button>
      <mat-divider></mat-divider>
      }
      @if (isMobileMenu) {
      <button mat-menu-item style="background-color: white" routerLink="/minha-conta/alterar-senha"><b>Alterar Senha</b></button>
      <mat-divider></mat-divider>
      }
      @if (isCliente) {
      <button mat-menu-item style="background-color: white" routerLink="/minha-conta/contatos"><b>Contatos</b></button>
      <mat-divider></mat-divider>
      }
      @if (isUsuario && isMobileMenu) {
      <button mat-menu-item style="background-color: white" routerLink="/minha-conta/consulta-gerencial-cadastro"><b>Cadastro de Consultas Gerenciais</b></button>
      <mat-divider></mat-divider>
      }
      @if (isCliente && isMobileMenu) {
      <button mat-menu-item style="background-color: white" routerLink="/minha-conta/consulta-gerencial"><b>Consulta Gerencial</b></button>
      <mat-divider></mat-divider>
      }
      @if (isUsuario && isMobileMenu) {
      <button mat-menu-item style="background-color: white" routerLink="/minha-conta/banner-cadastro"><b>Cadastro de Banners</b></button>
      <mat-divider></mat-divider>
      }
      <button mat-menu-item style="background-color: white" (click)="logout()"><b style="color: red;">Sair</b></button>
    </mat-menu>
  </div>
</div>
